import React, { useEffect, useState } from 'react';
import {
    Form,
    Input,
    Select,
    Upload,
    Avatar,
    Button,
    Alert,
    Typography
} from 'antd';
import {
    UsergroupAddOutlined ,
    UploadOutlined,
    UserOutlined,
} from '@ant-design/icons';
import axios from 'axios';

const { Option } = Select;
const { Title } = Typography;

const provinciasConCiudades = {
    "Buenos Aires": ["La Plata", "Mar del Plata", "Bahía Blanca", "Avellaneda", "Lanús", "Lomas de Zamora", "Quilmes", "Morón", "San Martín", "Tres de Febrero", "Vicente López", "San Isidro", "Tigre", "Pilar", "San Fernando", "Ituzaingó", "Merlo", "Moreno", "San Justo", "Ramos Mejía", "Gregorio de Laferrere", "Monte Grande", "Ezeiza", "Adrogué", "Burzaco", "Florencio Varela", "Berazategui", "General Rodríguez", "Chivilcoy", "Tandil", "San Nicolás de los Arroyos", "Junín", "Olavarría", "Pergamino", "Necochea", "Azul", "Luján", "Campana", "Zárate", "San Pedro"],
    "Ciudad Autónoma de Buenos Aires": ["Palermo", "Recoleta", "Belgrano", "Caballito", "Villa Urquiza", "San Telmo", "Retiro", "Almagro", "Núñez", "La Boca", "Barracas", "Flores", "Constitución", "Balvanera", "Monserrat", "Villa Devoto", "Mataderos", "Villa Lugano", "Villa Soldati"],
    "Catamarca": ["San Fernando del Valle de Catamarca"],
    "Chaco": ["Resistencia", "Sáenz Peña"],
    "Chubut": ["Rawson", "Comodoro Rivadavia"],
    "Córdoba": ["Córdoba", "Villa Carlos Paz", "Río Cuarto"],
    "Corrientes": ["Corrientes", "Goya"],
    "Entre Ríos": ["Paraná", "Concordia"],
    "Formosa": ["Formosa"],
    "Jujuy": ["San Salvador de Jujuy"],
    "La Pampa": ["Santa Rosa"],
    "La Rioja": ["La Rioja"],
    "Mendoza": ["Mendoza", "San Rafael"],
    "Misiones": ["Posadas", "Oberá"],
    "Neuquén": ["Neuquén", "San Martín de los Andes"],
    "Río Negro": ["Viedma", "Bariloche"],
    "Salta": ["Salta", "Orán"],
    "San Juan": ["San Juan"],
    "San Luis": ["San Luis", "Villa Mercedes"],
    "Santa Cruz": ["Río Gallegos", "Caleta Olivia"],
    "Santa Fe": ["Santa Fe", "Rosario"],
    "Santiago del Estero": ["Santiago del Estero", "La Banda"],
    "Tierra del Fuego": ["Ushuaia", "Río Grande"],
    "Tucumán": ["San Miguel de Tucumán"]
};

const RegistrarClientes = () => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [data, setData] = useState({
        avatar: "",
        nombre_completo: "",
        correo_electronico: "",
        celular: "",
        ciudad: "",
        provincia: "",
        direccion: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleProvinciaChange = (value) => {
        setData(prev => ({
            ...prev,
            provincia: value,
            ciudad: "" // Limpiar ciudad al cambiar provincia
        }));
    };

    const handleCiudadChange = (value) => {
        setData(prev => ({
            ...prev,
            ciudad: value
        }));
    };

    const handleFileChange = ({ fileList }) => {
        if (!fileList.length) return;

        const file = fileList[0].originFileObj;
        if (!file) return;

        setFileList(fileList[0]); // guardar el objeto completo para subir
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
    };




    useEffect(() => {
        return () => {
            if (previewImage) URL.revokeObjectURL(previewImage);
        };
    }, [previewImage]);

    const handleAddClient = async () => {
        setSubmitLoading(true);
        const token = localStorage.getItem('token');
        const usuarioId = localStorage.getItem('usuarioId');

        const formData = new FormData();
        formData.append('nombre_completo', data.nombre_completo);
        formData.append('correo_electronico', data.correo_electronico);
        formData.append('celular', data.celular);
        formData.append('ciudad', data.ciudad);
        formData.append('provincia', data.provincia);
        formData.append('direccion', data.direccion);
        formData.append('usuarioId', usuarioId);

        if (fileList) {
            formData.append('avatar', fileList.originFileObj);
        }

        try {
            await axios.post('https://elarigestion-production.up.railway.app/api/registrar-clientes', formData, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'multipart/form-data',
                },
            });

            setSuccessMessage('Cliente registrado correctamente');
            form.resetFields();
            setFileList(null);
            setPreviewImage(null);
            setData({
                avatar: "",
                nombre_completo: "",
                correo_electronico: "",
                celular: "",
                ciudad: "",
                provincia: "",
                direccion: "",
            });
        } catch (err) {
            const msg = err.response?.data?.message || err.message || 'Error desconocido';
            setErrorMessage(msg);
        } finally {
            setSubmitLoading(false);
        }
    };



    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem', justifyContent: 'center' }}>
  <UsergroupAddOutlined style={{ fontSize: 32, color: '#1890ff' }} />
  <Title level={2} style={{ margin: 0 }}>Registrar Cliente</Title>
</div>

        <Form
            form={form}
            layout="vertical"
            onFinish={handleAddClient}
            style={{ maxWidth: 600, margin: '0 auto' }}
        >
            <Form.Item label="Foto (opcional)">
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <Avatar
                        size={64}
                        src={previewImage}
                        icon={!previewImage && <UserOutlined />}
                        alt="Avatar preview"
                    />

                    <Upload
                        accept="image/*"
                        beforeUpload={() => false}
                        showUploadList={false}
                        onChange={handleFileChange}

                        fileList={[]} // ← ¡Importante! Evita que Upload mantenga su propio estado interno
                    >


                        <Button icon={<UploadOutlined />}>Seleccionar Imagen</Button>
                    </Upload>


                    {previewImage && (
                        <Button danger onClick={() => {
                            setPreviewImage(null);
                            setFileList(null);
                        }}>
                            Eliminar
                        </Button>
                    )}
                </div>

            </Form.Item>

            <Form.Item label="Nombre Completo" name="nombre_completo" rules={[{ required: true }]}>
                <Input name="nombre_completo" value={data.nombre_completo} onChange={handleChange} autoComplete="off" />
            </Form.Item>

            <Form.Item label="Correo Electrónico" name="correo_electronico" rules={[{ required: true, type: 'email' }]}>
                <Input name="correo_electronico" value={data.correo_electronico} onChange={handleChange} autoComplete="off" />
            </Form.Item>

            <Form.Item label="Celular" name="celular" rules={[{ required: true }]}>
                <Input name="celular" value={data.celular} onChange={handleChange} autoComplete="off" />
            </Form.Item>

            <Form.Item label="Provincia (opcional)" name="provincia">
                <Select
                    showSearch
                    placeholder="Selecciona una provincia"
                    value={data.provincia}
                    onChange={handleProvinciaChange}
                    autoComplete="off"
                >
                    {Object.keys(provinciasConCiudades).map((provincia) => (
                        <Option key={provincia} value={provincia}>
                            {provincia}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item label="Ciudad (opcional)" name="ciudad">
                <Select
                    showSearch
                    placeholder="Selecciona una ciudad"
                    value={data.ciudad}
                    onChange={handleCiudadChange}
                    disabled={!data.provincia}
                    autoComplete="off"
                >
                    {(provinciasConCiudades[data.provincia] || []).map((ciudad) => (
                        <Option key={ciudad} value={ciudad}>
                            {ciudad}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item label="Dirección (opcional)" name="direccion">
                <Input name="direccion" value={data.direccion} onChange={handleChange} />
            </Form.Item>

            {errorMessage && (
                <Alert
                    description={errorMessage}
                    type="error"
                    showIcon
                    closable
                    onClose={() => setErrorMessage(null)}
                    style={{ marginBottom: 16 }}
                />
            )}

            {successMessage && (
                <Alert
                    description={successMessage}
                    type="success"
                    showIcon
                    closable
                    onClose={() => setSuccessMessage(null)}
                    style={{ marginBottom: 16 }}
                />
            )}

            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={submitLoading}
                    block
                >
                    Guardar Cliente
                </Button>
            </Form.Item>
        </Form>
        </div>

    );
};

export default RegistrarClientes;
